import { createApp } from 'vue'
import App from './App.vue'
import VueMatomo from 'vue-matomo'
import router from './router'

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import '@/assets/scss/globalColors.scss';
import '@/assets/css/general.css';
import VueSvgInlinePlugin from "vue-svg-inline-plugin";
import "vue-svg-inline-plugin/src/polyfills";

const app = createApp(App);

app.config.globalProperties.$scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Omitir para un salto instantáneo sin animación
  });
};

app.config.globalProperties.$scrollInTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'instant' // Omitir para un salto instantáneo sin animación
  });
};

app.config.globalProperties.$filters = {
    cap(data) {
        var capitalized = []
        data.split(' ').forEach(word => {
          capitalized.push(
            word.charAt(0).toUpperCase() +
            word.slice(1).toLowerCase()
          )
        })
        return capitalized.join(' ')
    },
    cash(value){
      if (typeof value !== "number") {
          return value;
      }
      var formatter =  value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
      return formatter
    },
    cash2(value){
      if (typeof value !== "number") {
          return value;
      }
      var formatter =  value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return formatter
    },
    cash3(value){
      if (typeof value !== "number") {
          return value;
      }
      if (value == 0) {
          return '';
      }
      var formatter =  '+ $'+value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return formatter
    },
    cash4(value){
      if (typeof value !== "number") {
          return value;
      }
      if (value == 0) {
          return '';
      }
      var formatter =  '$ '+value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return formatter
    },
    resVal(res) {
      if(!res){
        return false
      }
      if(res.code != "200"){
          return false
      }
      if(res.data === undefined){
          return false
      }
      return true
    },
    resErr(res) {
      if(!res){
        return false
      }
      if(res.msj === undefined){
          return false
      }
      return true
    }
}

app.use(VueSvgInlinePlugin);
app.use(VueSvgInlinePlugin, {
	attributes: {
		data: [ "src" ],
		remove: [ "alt" ]
	}
});

app.use(router);
app.use(VueMatomo, {
  host: 'https://dashboard.efisense.net/analytics',
  siteId: 8,
  router, //el plugin registra su propio afterEach: setCustomUrl + trackPageView por ruta (usa meta.title como nombre)
  //trackInitialView viene en true por defecto, por eso ya no se llama trackPageView a mano tras el mount
});

app.mount('#app');
